import { createStyle } from "~/common/utils/create-style";

const dropdownStyle = createStyle({
  slots: {
    triggerButton: [
      "w-full flex flex-row items-center justify-between gap-8",
      "!text-body-2-emphasis text-text-primary p-8 rounded-l ",
      "data-[state=open]:bg-overlay-30 hover:bg-color-overlay-30 hover:cursor-pointer",
    ],
    triggerButtonContent: "flex gap-8 items-center",
    dropdownContainer: [
      "w-[24rem] rounded-xl bg-white",
      "text-text-primary-on-light p-8 z-999",
    ],
    dropdownItem: [
      "flex items-center gap-8 p-8 px-4 rounded-l text-body-2 justify-between",
      "hover:outline-none hover:bg-overlay-on-light-30 hover:cursor-pointer",
      "data-[disabled]:text-text-disabled-on-light data-[disabled]:cursor-not-allowed",
    ],
    workspaceInfoWrapper: ["flex items-center justify-between gap-8"],
    image: ["rounded-[5px] h-[20px] w-[20px]"],
  },
  variants: {
    theme: {
      light: {
        dropdownContainer:
          "border-color-border-opacity-20 shadow-[0_-1px_3px_rgba(0,0,0,0.08),0_4px_6px_rgba(0,0,0,0.08)]",
      },
    },
  },
})();

export { dropdownStyle };
